<form [formGroup]="petitionForm">
    <div>
        <mat-form-field>
            <mat-label for="text">Text: </mat-label>
            <input matInput id="text" formControlName="text" />
        </mat-form-field>
    </div>
    <mat-form-field>
        <mat-label>Category</mat-label>
        <mat-select formControlName="category">
            <mat-option *ngFor="let category of (categories$ | async)" [value]="category._id">
                {{category.name}}
            </mat-option>

            <mat-option [value]="null">
                Uncategorized
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <mat-label>Range of effective dates</mat-label>
        <mat-date-range-input formGroupName="dateRange" [rangePicker]="dateRangePicker">
            <input matStartDate formControlName="begin" placeHolder="Begin date" />
            <input matEndDate formControlName="end" placeholder="End date" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
    </mat-form-field>
    <mat-checkbox formControlName="isAnnual">Is annual commemoration</mat-checkbox>
    <mat-divider></mat-divider>
</form>